import React from "react";
import styled from "styled-components";
import FullScreenOverlay from "../../common/FullScreenOverlay";
import EditableAvatar from "../../common/EditableAvatar";

const AccountModal = ({ onClose, user }) => {
  const raw = user.mdt_roles;
  const displayRole = Array.isArray(raw)
    ? // if array of strings coming back from update
      raw[0] || ""
    : // if plain string coming back from GET
      raw;
  return (
    <>
      {
        <FullScreenOverlay
          title="Account details"
          onClose={onClose}
          width="480px"
          height="auto"
          isPopup={false}
          iconClose={true}
          isSlimModal={true}
          footerButtons={[
            { label: "Close", onClick: onClose, variant: "primary" },
          ]}
        >
          <Content>
            {/* Profile Section */}
            <ProfileSection>
              <EditableAvatar user={user} />
              <UserInfo>
                <UserName>{user.name}</UserName>
                <UserEmail>{user.email}</UserEmail>
              </UserInfo>
            </ProfileSection>

            {/* MDT Role Section */}
            <RoleSection>
              <SectionHeader>MDT role</SectionHeader>
              <Role>{displayRole}</Role>
            </RoleSection>
          </Content>
        </FullScreenOverlay>
      }
    </>
  );
};

export default AccountModal;

/*----------------- Styled Components -----------------*/

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;
`;

const ProfileSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 24px;
`;

const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const UserName = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #000;
`;

const UserEmail = styled.div`
  font-size: 14px;
  color: #666;
`;

const RoleSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

const SectionHeader = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #000;
`;

const Role = styled.div`
  font-size: 14px;
  color: #666;
`;
